import { ID, NewVision, Vision } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';
import { withRoles } from '../utils/with-roles';

export type CreateVisionOptions<
  TDocRef = unknown,
  TCollectionRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  vision: NewVision;
  userId: ID;
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollectionRef;
  doc: (
    collectionRef: NoInfer<TCollectionRef>,
    ...rest: string[]
  ) => TDocRef & { id: string };
  setDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void> | void;
  db: TDb;
  serverTimestamp: () => TFieldValue;
};

export const createVision = async <
  TDocRef,
  TCollectionRef,
  TFieldValue,
  TDb = FirestoreInstance,
>({
  vision,
  userId,
  collection,
  doc,
  setDoc,
  db,
  serverTimestamp,
}: CreateVisionOptions<
  TDocRef,
  TCollectionRef,
  TFieldValue,
  TDb
>): Promise<Vision> => {
  const collectionRef = collection(db, FirestoreCollections.Visions);
  const newDoc = doc(collectionRef);

  const newDocData = withRoles(
    {
      id: newDoc.id,
      description: vision.description ?? '',
      images: vision.images ?? [],
      lifeAreaId: vision.lifeAreaId ?? null,
      frozenAt: null,
    },
    userId,
  );

  await setDoc(newDoc, {
    ...newDocData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return {
    ...newDocData,
    createdAt: new Date(),
  };
};
